<template>
  <div class="share">
    <el-card>
      <div slot="header" class="clearfix">
        文件分享
      </div>
      <el-form label-width="100px">
        <el-form-item label="密码">
          <el-input v-model="passWord"></el-input>
        </el-form-item>
        <el-form-item label="有效时间">
          <el-select v-model="limitTime">
            <el-option v-for="(i, index) in secTime" :key="index" :label="i.name" :value="i.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分享权限">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="预览" disabled></el-checkbox>
            <el-checkbox label="下载"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <el-form>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">生成分享链接</el-button>
          <el-button @click="cancle">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'share',
  props: ['modalInfo'],
  data() {
    return {
      passWord: null,
      limitTime: 0,
      pubPwd: '',
      secTime: [
        {
          name: '今天',
          value: 0
        },
        {
          name: '本周',
          value: 1
        },
        {
          name: '本月',
          value: 2
        }
      ],
      checkList: ['预览']
    }
  },
  created() {
    console.log(this.modalInfo)
    this.getPublishPwd()
  },
  methods: {
    cancle() {
      this.$store.commit('closeModal', 'share')
    },
    getPublishPwd() {
      let params = new FormData()
      params.append('module', 'WebClient')
      params.append('fun', 'GetProcessStrategyByKey')
      params.append('entryId', 1)
      params.append('entryType', 1)
      ApiService.oct_doc.common(params).then(res => {
        this.passWord = res.PublishPwd
        this.pubPwd = res.PublishPwd
      })
    },
    shareFile() {
      let params = new FormData()
      params.append('module', 'PublishManager')
      params.append('fun', 'CreateFilePublish')
      params.append('fileIdList', this.modalInfo.FileId)
      params.append('endTime', '2019-11-8 00:00:00')
      params.append('outpublishName', this.modalInfo.FileName)
      params.append('outpublishPwd', this.pubPwd)
      params.append('outpublishRemark', '')
      params.append('outpublishAuthType', this.passWord === '' ? 2 : 1)
      params.append('canDownload', true)
      params.append('canSetDownloadTime', false)
      params.append('downloadTime', '')
      params.append('canEdit', false)
      params.append('canpreviewTime', false)
      params.append('previewTimes', '')
      ApiService.oct_doc.common(params).then(res => {
        console.log(res)
      })
    }
  }
}
</script>
<style lang="scss">
.share {
  .el-card__body {
    width: 400px;
    .el-select {
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mind/share.vue